import { createReducer } from '@reduxjs/toolkit'
import { createBuilder } from 'packages/redux-toolkit'

import { getAllTetrisLogs } from './actions'

interface TetrisLogsState {
  list: {
    loading: boolean
    items: string[]
  }
}

const initialState: TetrisLogsState = {
  list: {
    loading: false,
    items: [],
  },
}

export const tetrisLogsReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllTetrisLogs.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllTetrisLogs.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllTetrisLogs.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload.logFileNames
    })
})
